import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus, ArrowRight } from 'lucide-react';
const advantages = [{
  id: '01',
  title: 'Manufacturer-level after-sales',
  description: 'Our in-house engineers fix issues with proprietary hardware and training — no 4-6 week waits for manufacturer callouts that rivals depend on.'
}, {
  id: '02',
  title: 'Quality installs that last',
  description: 'Our installations consistently deliver 16-year lifespans. We never cut corners on materials or workmanship, saving you money long-term.'
}, {
  id: '03',
  title: 'Detailed service reports',
  description: 'Every visit includes comprehensive photo documentation — before and after. Reports that wow clients and make contract renewals effortless.'
}, {
  id: '04',
  title: 'Above-standard accreditations',
  description: 'Constructionline Gold (held by just 1-2% of firms), CHAS, SafeContractor, REFCOM, F-Gas certified. We go well beyond the industry baseline.'
}, {
  id: '05',
  title: 'TM44 compliance experts',
  description: 'Branded in-house TM44 inspections linked to ISO14001. Required every 5 years for systems over 12kW — we handle it all.'
}];
export function Advantages() {
  const [openId, setOpenId] = useState<string | null>('01');
  return <section className="py-24 bg-primary-light" data-id="element-18">
      <div className="container mx-auto px-6" data-id="element-19">
        <div className="grid lg:grid-cols-2 gap-16 items-start" data-id="element-20">
          <div data-id="element-21">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-4xl md:text-5xl mb-12 max-w-md" data-id="element-22">
              Why choose AccuTemp
            </motion.h2>

            <div className="space-y-2" data-id="element-23">
              {advantages.map(adv => <div key={adv.id} className="border-b border-primary-dark/10 last:border-0" data-id="element-24">
                  <button onClick={() => setOpenId(openId === adv.id ? null : adv.id)} className="w-full py-6 flex items-center justify-between text-left group" data-id="element-25">
                    <div className="flex items-center gap-6" data-id="element-26">
                      <span className="text-sm text-primary-dark/40 font-medium" data-id="element-27">
                        {adv.id}
                      </span>
                      <span className={`text-lg font-medium transition-colors ${openId === adv.id ? 'text-primary-dark' : 'text-primary-dark/70 group-hover:text-primary-dark'}`} data-id="element-28">
                        {adv.title}
                      </span>
                    </div>
                    <img src="https://cdn.magicpatterns.com/uploads/oA3faeBPf8gtucGgHUC7kH/arrow-down-navy.svg" alt="" className={`w-5 h-5 transition-transform duration-300 ${openId === adv.id ? 'rotate-180' : ''}`} data-id="element-29" />
                  </button>
                  <AnimatePresence data-id="element-30">
                    {openId === adv.id && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3
                }} className="overflow-hidden" data-id="element-31">
                        <p className="pb-6 pl-12 text-primary-dark/70 text-sm leading-relaxed max-w-md" data-id="element-32">
                          {adv.description}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>)}
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="relative h-[600px] rounded-2xl overflow-hidden" data-id="element-33">
            <img src="https://images.unsplash.com/photo-1621905252507-b35492cc74b4?w=600&q=80" alt="Worker" className="w-full h-full object-cover" data-id="element-34" />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-dark/80 via-transparent to-transparent" data-id="element-35"></div>

            <div className="absolute bottom-8 left-8 right-8 flex justify-end" data-id="element-36">
              <button className="group flex items-center gap-4 bg-accent hover:bg-accent/90 text-white px-6 py-3 rounded-full transition-all duration-300 backdrop-blur-sm" data-id="element-37">
                <span className="font-medium text-sm" data-id="element-38">
                  Request a free quote
                </span>
                <img src="https://cdn.magicpatterns.com/uploads/bPzFdwHywdHpFHfUSsV2QY/arrow-right-circle-white.svg" alt="" className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-39" />
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}